const TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";
// access_token
export const addUserToLocalStorage = (data) => {
  localStorage.setItem(TOKEN_KEY, data.access_token);
  localStorage.setItem(REFRESH_TOKEN_KEY, data.refresh_token);
};

export const removeUserFromLocalStorage = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  // window.location.reload();
};

export const getAccessTokenFromLocalStorage = () => {
  const result = localStorage.getItem(TOKEN_KEY);
  const access_token = result ? result : null;
  return access_token;
};

export const getRefreshTokenFromLocalStorage = () => {
  const result = localStorage.getItem(REFRESH_TOKEN_KEY);
  const access_token = result ? result : null;
  return access_token;
};

// user detail from token
export const getUserDetailFromToken = () => {
  const access_token = getAccessTokenFromLocalStorage();
  if (access_token) {
    const tokenPayload = access_token.split(".")[1];
    const decodedPayload = JSON.parse(atob(tokenPayload));
    return { id: decodedPayload.id, roles: decodedPayload.roles };
  }
  return { id: null, roles: [] };
};
// is login
export const isLogin = () => {
  const result = localStorage.getItem(TOKEN_KEY);
  return result ? true : false;
};
// language
export const addLanguageToLocalStorage = (language) => {
  localStorage.setItem("i18nextLng", JSON.stringify(language));
};

export const removeLanguageFromLocalStorage = () => {
  localStorage.removeItem("i18nextLng");
};

export const getLanguageFromLocalStorage = () => {
  const result = localStorage.getItem("i18nextLng");
  return result ? result : "sr";
};

//cart
export const addCartToLocalStorage = (cart) => {
  localStorage.removeItem("cart");
  localStorage.setItem("cart", JSON.stringify(cart));
};
export const getCartFromLocalStorage = (cart) => {
  const result = localStorage.getItem("cart");
  return result ? JSON.parse(result) : null;
};
export const removeCartFromLocalStorage = () => {
  localStorage.removeItem("cart");
};
